import React from "react";
import * as Icon from "react-feather";

import "./tools-code-block.css";
import WComponent from "../../../common/WComponent";

class ToolsCodeBlock extends WComponent {
	constructor(props) {
		super(props);
		const { startsFolded = true } = props;
		this.state = { isOpen: !startsFolded };
	}

	onToggle = () => {
		this.setState(previous => ({ isOpen: !previous.isOpen }));
	};

	render() {
		const { code, label = "code" } = this.props;
		const { isOpen } = this.state;
		const toggleWording = isOpen ? "Hide " + label : "Show " + label;

		return (
			<div className="tools-code-block">
				<button type="button" className="tk-text-action" onClick={this.onToggle} aria-expanded={isOpen}>
					{isOpen ? (
						<Icon.ChevronUp size={14} className="tools-code-block__chevron" />
					) : (
						<Icon.ChevronDown size={14} className="tools-code-block__chevron" />
					)}
					{toggleWording}
				</button>
				{isOpen && (
					<pre className="tools-code-block__pre" tabIndex={0}>
						<code>{code}</code>
					</pre>
				)}
			</div>
		);
	}
}

export default ToolsCodeBlock;
